module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Medium.eb76c06.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NotoSansKR-Medium.woff2
// module id = w7S2
// module chunks = 10